/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elevenlabs_Scribe_Limit_WarningInputs */



/**
* | output |
* | --- |
* | "ElevenLabs Scribe only supports files up to 2 hours in length." |
*
* @param {Elevenlabs_Scribe_Limit_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const elevenlabs_scribe_limit_warning = /** @type {((inputs?: Elevenlabs_Scribe_Limit_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elevenlabs_Scribe_Limit_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ElevenLabs Scribe ne prend en charge que les fichiers d’une durée maximale de 2 heures.")
	if (locale === "de") return /** @type {LocalizedString} */ ("ElevenLabs Scribe unterstützt nur Dateien mit einer Länge von bis zu 2 Stunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("ElevenLabs Scribe supporta solo file lunghi fino a 2 ore.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ElevenLabs Scribe поддерживает файлы продолжительностью до 2 часов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("ElevenLabs Scribe solo admite archivos de hasta 2 horas de duración.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ElevenLabs Scribe 仅支持时长不超过 2 小时的文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ElevenLabs Scribe は、最長 2 時間までのファイルのみをサポートします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ElevenLabs Scribe केवल 2 घंटे तक की लंबाई वाली फाइलों को ही सपोर्ट करता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O ElevenLabs Scribe suporta apenas arquivos com duração de até 2 horas.")
	return /** @type {LocalizedString} */ ("ElevenLabs Scribe only supports files up to 2 hours in length.")
});